import { gql } from '@apollo/client'

export const KUSTOMER_CONVERSATIONS = gql`
  query kustomerConversations {
    kustomerConversations {
      conversations {
        id
        name
        preview
        status
      }
    }
  }
`
